export default __webpack_public_path__ + "static/media/pH_scale_poster.cd6b94d6.svg";